import Modal from 'react-modal';
import "../../styles/AdminPage.css";
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import CopyLink from "../../components/CopyLink";
import { FaTimes } from "react-icons/fa";
import { getAttendanceLink } from '../../api/admin/AdminDashboardAPI';
import html2canvas from 'html2canvas';
import WiCLogo from "../../assets/images/logo.png"

Modal.setAppElement('#root');

const QRCodeModal = ({ isOpen, onClose, event }) => {

    const [attendanceLink, setAttendanceLink] = useState("");
    const [loading, setLoading] = useState(true);
    const qrCodeRef = useRef(null);


    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                const link = await getAttendanceLink(event.id);

                setAttendanceLink(link);

            } catch (error) {
                console.error("Error fetching attendance link", error);
            } finally {
                setLoading(false);
                console.log("not loading");
                console.log("link: " + attendanceLink);
            }
        })();

    }, [event.id]);



    const handleDownload = () => {
        if (qrCodeRef.current) {
            html2canvas(qrCodeRef.current).then((canvas) => {
                const image = canvas.toDataURL("image/png");
                const link = document.createElement("a");
                link.href = image;
                link.download = event.eventName + " qrcode.png";
                link.click();
            });
        }
    };
    



    if (loading) {
        return (
            <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="QR Code Modal"
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-5'>
                    <h2 className="text-start mb-0">Record Attendance</h2>
                    <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                        <button className="close-btn" onClick={onClose}>{<FaTimes />}</button>
                    </div>
                </div>

                <div className='d-flex justify-content-center mb-5'>
                    <div>Loading...</div>
                </div>
            </>
        </Modal>
        );
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="QR Code Modal"
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-5'>
                    <h2 className="text-start mb-0">Record Attendance</h2>
                    <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                        <button className="close-btn" onClick={onClose}>{<FaTimes />}</button>
                    </div>
                </div>

                <div className='d-flex justify-content-center mb-3' ref={qrCodeRef} onClick={handleDownload} style={{cursor: 'pointer'}}>
                    <QRCode
                        value={attendanceLink}
                        size={256}
                        style={{ height: "auto", maxWidth: "65%", width: "65%" }}
                        // logoImage={WiCLogo}
                    />
                </div>
                <div>
                    <CopyLink id='copy-link' value={attendanceLink}/>
                </div>
            </>
        </Modal>
    );
};

QRCodeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default QRCodeModal;
